const NotFound = () => {
  return (
    <div className="utility-page-wrap">
      <div className="_404-wrap">
        <div className="_404-content-wrap">
          <div className="heading-jumbo">Page Not Found</div>
          <div className="paragraph-bigger cc-bigger-light">
            The page you are looking for doesn&#x27;t exist or has been moved.
          </div>
        </div>
        <a href="index.html" className="button cc-white-button w-inline-block">
          <div>Go Back to Safety</div>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
